import { Link, Typography } from "@mui/material";
import { FC, Fragment } from "react";
import { v4 } from "uuid";

const HelperText: FC<{
  helperText: string;
}> = ({ helperText }) => {
  let tmp: HTMLTextAreaElement = document.createElement("textarea");
  tmp.innerHTML = helperText;
  const decodedHelperText: string = tmp.value;

  const anchorRegEx = /<a[^>]*>([^<]+)<\/a>/g;
  const anchorsStr: RegExpMatchArray | null =
    decodedHelperText.match(anchorRegEx);
  const anchors: HTMLAnchorElement[] =
    anchorsStr?.map((anchor) => {
      const element = document.createElement("html");
      element.innerHTML = anchor;
      return element.getElementsByTagName("a")[0];
    }) ?? ([] as HTMLAnchorElement[]);

  const anchoredReplacedText: string = decodedHelperText.replace(
    anchorRegEx,
    "anchorTag"
  );
  const splittedText: string[] = anchoredReplacedText.split(/(anchorTag)/g);

  let buildReactComp = (
    splittedText: string[],
    anchors: IterableIterator<[number, HTMLAnchorElement]>
  ) =>
    splittedText.map((t: string) => {
      if (t === "anchorTag") {
        const theAnchor: HTMLAnchorElement = (
          anchors.next().value as [number, HTMLAnchorElement]
        )[1];
        return (
          <Link
            key={theAnchor.href}
            href={theAnchor.href}
            target={theAnchor.target}
          >
            {theAnchor.innerHTML}
          </Link>
        );
      } else {
        return (
          <Typography sx={{ whiteSpace: "pre-line" }} variant="caption" key={t}>
            {t}
          </Typography>
        );
      }
    });

  return <Fragment>{buildReactComp(splittedText, anchors.entries())}</Fragment>;
};

export default HelperText;
//HelperText.whyDidYouRender = true;
